const AUTH_RETURN_TO_KEY = 'optioneer_auth_return_to'

function isSafeReturnTo(value: string | null | undefined): value is string {
  return Boolean(value && value.startsWith('/') && !value.startsWith('//'))
}

export function normalizeReturnTo(value: string | null | undefined): string | null {
  return isSafeReturnTo(value) ? value : null
}

export function persistAuthReturnTo(value: string | null | undefined) {
  const normalized = normalizeReturnTo(value)
  if (!normalized) return
  sessionStorage.setItem(AUTH_RETURN_TO_KEY, normalized)
}

export function readAuthReturnTo(): string | null {
  return normalizeReturnTo(sessionStorage.getItem(AUTH_RETURN_TO_KEY))
}

export function consumeAuthReturnTo(): string | null {
  const value = readAuthReturnTo()
  sessionStorage.removeItem(AUTH_RETURN_TO_KEY)
  return value
}
